<template>
  <div class="min-h-screen relative">
    <!-- <Header /> -->
    <!-- <FlashMessage v-if="this.messages.text != ''" :message="this.messages" /> -->

    <div
      class="min-h-screen container mx-auto max-w-[1200px] w-full mb-10 py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div
        v-if="loading"
        class="flex items-center justify-center"
        style="height: calc(100vh - 350px) !important"
      >
        <img src="@/assets/newd/loading.gif" alt="" />
      </div>
      <!-- new -->
      <div v-else class="p-4">
        <div class="flex flex-wrap gap-2 mb-4">
          <!-- {{  }} -->
          <!-- {{ this.sem_course[0].semester }} 
          {{ activeTab }}  -->

          <div
            v-if="sem_course.length == 0"
            class="flex justify-center w-full sm:p-6 h-auto"
          >
            <p class="text-sm">No Semesters</p>
          </div>

          <!-- <button
            v-for="tab in sem_course"
            :key="tab.semester"
            @click="selectTab(tab)"
            :class="[
              'px-4 py-2 rounded text-sm transition duration-200',
              activeTab === tab.semester
                ? 'bg-blues text-white'
                : semesterToNumber(tab.semester) <=
                  semesterToNumber(userInfo.current_semester.semester)
                ? 'bg-gray-300 text-gray-700 hover:bg-gray-300'
                : // Future semesters → lighter gray
                  'bg-gray-200 text-gray-500 hover:bg-gray-300',
            ]"
          >
            Semester<b class="pl-1">{{ tab.semester }}</b>
          </button> -->
          <!-- <template v-for="tab in sem_course">
            <button
              v-if="tab.semester === userInfo.current_semester.semester"
              :key="tab.semester"
              @click="selectTab(tab)"
              class="px-4 py-2 rounded text-sm transition duration-200 bg-blues text-white"
            >
              Semester<b class="pl-1">{{ tab.semester }}</b>
            </button>
          </template> -->

          <!-- new -->
          <div v-for="tab in sem_course" :key="tab.semester">
            <button
             v-if="semesterToNumber(tab.semester.id) <= semesterToNumber(studentdata.semesterId)"
              @click="selectTab(tab)"
              :class="[
                'px-4 py-2 rounded text-sm transition duration-200',
                activeTab === tab.semester &&
                activeDepartment === tab.department.name
                  ? 'bg-blues text-white'
                  : semesterToNumber(tab.semester.id) <=
                    semesterToNumber(studentdata.semesterId)
                  ? 'bg-gray-200 border text-gray-700 hover:bg-gray-300'
                  : 'bg-gray-200 text-gray-500 hover:bg-gray-300',
              ]"
            >
              Semester <b class="pl-1">{{ tab.semester }}</b>
              <span
                class="ml-2 text-xs font-bold"
                :class="
                  activeTab === tab.semester &&
                  activeDepartment === tab.department.name
                    ? 'text-white'
                    : 'text-gray-600'
                "
              >
                ({{ tab.department.name }})
              </span>
            </button>
          </div>
        </div>

        <div v-if="activeTab">
          <div class="flex flex-row items-center justify-between">
            <p
              class="text-[#0F172A] text-lg sm:text-xl md:text-xl font-semibold"
            >
              My Courses
            </p>
          </div>

          <div class="">
            <!-- {{ getCourseListbySemester[0].course }} -->
           <div v-if="getCourseListbySemester.length > 0">
  <div
    v-if="getCourseListbySemester[0]"
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6"
  >
    <!-- Loop safely over courses -->
    <div
      v-for="course in getCourseListbySemester[0].course || []"
      :key="course.id"
      class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
      :class="{
        'cursor-not-allowed bg-gray-100 opacity-70': isCourseDisabled(),
        'cursor-pointer': !isCourseDisabled(),
      }"
      @click="!isCourseDisabled() && getDashboardOrPreviewUp(course.id)"
    >
      <div>
        <div class="relative flex justify-center items-center">
          <img
            v-if="course.thumbnail"
            class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
            :src="course.thumbnail"
            alt="Course Thumbnail"
          />
          <img
            v-else
            class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
            src="@/assets/coding.svg"
            alt="Placeholder"
          />
        </div>
        <div class="text-center flex flex-col gap-2 mt-2">
          <p class="text-sm sm:text-base text-gray-600 font-semibold text-left truncate">
            {{ course.title }}
          </p>
          <p class="text-xs sm:text-sm text-gray-600 text-left">
            <span class="font-bold">Course Code:</span>
            {{ course.course_code }}
          </p>

          <p
            @click.stop="!isCourseDisabled() && getDashboardOrPreviewUp(course.id)"
            class="mt-3 py-2 text-xs sm:text-sm rounded-lg border border-[#0085DB] hover:bg-hover hover:text-white text-[#0F172A] font-medium text-center"
            :class="{
              'cursor-not-allowed bg-gray-100 opacity-70': isCourseDisabled(),
              'cursor-pointer': !isCourseDisabled()
            }"
          >
            Continue Learning
          </p>
        </div>
      </div>
    </div>

    <!-- Empty courses fallback -->
    <div
      v-if="!getCourseListbySemester[0].course || getCourseListbySemester[0].course.length === 0"
      class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
    >
      <p class="text-sm">No Courses</p>
    </div>
  </div>
</div>
          </div>
        </div>
      </div>

      <!-- old -->
      <div class="hidden">
        <div class="flex flex-row items-center justify-between">
          <p
            class="text-[#0F172A] text-xl sm:text-2xl md:text-3xl font-semibold"
          >
            My Courses
          </p>
        </div>

        <div
          v-if="loading"
          class="flex items-center justify-center"
          style="height: calc(100vh - 350px) !important"
        >
          <img src="@/assets/newd/loading.gif" alt="" />
        </div>
        <div class="" v-else>
          <div v-if="this.courseDetails.length > 0">
            <div
              v-if="this.courseDetails[0]"
              class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6"
            >
              <div
                v-for="course in this.courseDetails[0].course"
                :key="course"
                class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
              >
                <!-- <router-link 
                  :to="{
                    name: 'StudentCourse',
                    params: { courseid: course.id },
                  }"
                >
                  <div class="relative flex justify-center items-center">
                    <img
                      v-if="course.thumbnail"
                      class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                      :src="course.thumbnail"
                      alt="Course Thumbnail"
                    />
                    <img
                      v-else
                      class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                      src="@/assets/coding.svg"
                      alt="Placeholder"
                    />
                  </div>
                  <div class="text-center flex flex-col gap-2 mt-2">
                    <p
                      class="text-sm sm:text-base text-gray-600 font-semibold text-left truncate"
                    >
                      {{ course.title }}
                    </p>
                    <p class="text-xs sm:text-sm text-gray-600 text-left">
                      {{ course.sections.length }} Units
                    </p>

                    <p
                      class="mt-3 py-2 text-xs sm:text-sm rounded-lg border border-[#0085DB] text-[#0F172A] font-medium text-center"
                    >
                      Continue Learning
                    </p>
                  </div>
                </router-link> -->

                <div
                  @click="getDashboardOrPreviewUp(course.id)"
                  class="cursor-pointer"
                >
                  <div class="relative flex justify-center items-center">
                    <img
                      v-if="course.thumbnail"
                      class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                      :src="course.thumbnail"
                      alt="Course Thumbnail"
                    />
                    <img
                      v-else
                      class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                      src="@/assets/coding.svg"
                      alt="Placeholder"
                    />
                  </div>
                  <div class="text-center flex flex-col gap-2 mt-2">
                    <p
                      class="text-sm sm:text-base text-gray-600 font-semibold text-left truncate"
                    >
                      {{ course.title }}
                    </p>
                    <p class="text-xs sm:text-sm text-gray-600 text-left">
                      {{ course.sections.length }} Units
                    </p>

                    <p
                      @click="getDashboardOrPreviewUp(course.id)"
                      class="mt-3 cursor-pointer py-2 text-xs sm:text-sm rounded-lg border border-[#0085DB] text-[#0F172A] font-medium text-center"
                    >
                      Continue Learning
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-if="this.courseDetails[0].course.length == 0"
                class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
              >
                <p class="text-sm">No Courses</p>
              </div>
            </div>

            <div v-else class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto">
              <p class="text-sm">No Courses</p>
            </div>
          </div>

          <div
            v-else
            class="flex flex-col justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <p class="flex justify-center">No Courses</p>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Student/Header.vue";

export default {
  data() {
    return {
      profileInfo: null,
      popUp: false,
      updateDetails: null,
      selectedFile: null,
      tnxDetails: "",
      profile: false,
      // messages: {
      //   text: "",
      //   type: "null",
      // },
      selectedcontent: "Courses",
      // courseDetails: null,
      courseDetails: [],
      boughtcourse: null,
      progress: 90,
      loading: true,
      activeTab: null,
      sem_course: [],
      sem_courselist: [],
      getCourseListbySemester: [],
    };
  },

  components: {
    Header,
    // FlashMessage,
    Footer,
  },
  computed: {
     ...mapGetters("student", [
      "studentdata"]),
  },

  mounted() {
    // this.activeTab = this.userInfo.current_semester.semester;
    if (!localStorage.getItem("previewIgnoreList")) {
      localStorage.setItem("previewIgnoreList", JSON.stringify([]));
    }

    // setTimeout(()=>{

    //   // console.log("get::", this.sem_course);

    //   if (this.sem_course[0]) {
    //     this.activeTab = this.sem_course[0].semester;
    //     this.getsemestercourse(this.sem_course[0].semester);
    //   }
    // }, 100)
  },

  async created() {
    this.getsemester();

    //   await axios
    //     .get(`${process.env.VUE_APP_API}/courses/?format=json`)
    //    .then((response) => {
    // this.courseDetails = response.data.data;
    // this.loading = false;

    // https://api.galecta.com/studentsbuycoursedetails/?Key=cff90a4514d5ab813c34782fe83297598cdf099e
    // });

    await axios
      .get(
        `${process.env.VUE_APP_API}/studentsbuycoursedetails/?Key=${this.studentdata.studentToken}`,
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.courseDetails = response.data.data;
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
  },

  methods: {
    semesterToNumber(sem) {
      const map = { I: 1, II: 2, III: 3, IV: 4, V: 5, VI: 6 };
      return map[sem] || 0;
    },
    isDisabled(tab) {
      const current = this.semesterToNumber(
        this.studentdata.semesterId,
      );
      const tabSem = this.semesterToNumber(tab.semester.id);
      return tabSem > current;
    },
    selectTab(tab) {
      this.getsemestercourse(tab.id);
      this.activeTab = tab.semester;
      this.activeDepartment = tab.department.name;
    },

    getDashboardOrPreviewUp(id) {
      console.log("tsdfd///",id)
      if (localStorage.getItem("previewIgnoreList")) {
        let preList = new Set(
          JSON.parse(localStorage.getItem("previewIgnoreList")),
        );

        if (preList.size != 0) {
          if (preList.has(id.toString())) {
            this.$router.push({
              name: "PreviewStudentCourseProgress",
              params: { course_id: id },
            });
          } else {
            this.$router.push({
              name: "PreviewStudentCourse",
              params: { course_id: id },
            });
          }
        } else {
          this.$router.push({
            name: "PreviewStudentCourse",
            params: { course_id: id },
          });
        }
      } else {
        this.$router.push({ name: "PreviewStudentCourse", params: { course_id: id } });
      }
    },

    // old
    // async getsemester() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/student-semester-get/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}`,
    //     )
    //     .then((response) => {
    //       if (response.data.data.status == 200) {
    //         console.log("this.sem_course12", response.data.data.status);
    //         this.sem_course = response.data.data.data[0].semester.reverse();
    //         const currentSem = this.userInfo.current_semester.semester;
    //         const found = this.sem_course.find(
    //           (tab) => tab.semester === currentSem,
    //         );

    //         if (found) {
    //           this.activeTab = found.semester;
    //           this.getsemestercourse(found.semester);
    //         } else if (this.sem_course[0]) {
    //           this.activeTab = this.sem_course[0].semester;
    //           this.getsemestercourse(this.sem_course[0].semester);
    //         }

    //         console.log("this.sem_course", this.sem_course);
    //         setTimeout(() => {
    //           this.loading = false;
    //         }, 600);
    //       }
    //     });
    // },
  isCourseDisabled() {
    if (!this.getCourseListbySemester[0] || !this.getCourseListbySemester[0].semester) return true;
    return this.getCourseListbySemester[0].semester.id > this.studentdata.semesterId;
  },
    // new
    async getsemester() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-semester-get/${this.studentdata.studentId}/?Key=${this.studentdata.studentToken}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            console.log("this.sem_course12", response.data.data.status);
            this.sem_course = response.data.data.data[0].semester.reverse();
            const currentSem = this.studentdata.semesterId;
            const currentDepartment = this.studentdata.department;
            const found = this.sem_course.find(
              (tab) =>
                tab.semester === currentSem &&
                tab.department.name === currentDepartment,
            );
            console.log("found", found);

            if (found) {
              this.activeTab = found.semester;
              this.activeDepartment = found.department.name;
              console.log("foactiveDepartment1", this.activeDepartment);
              console.log("foactiveDepartment123", found.id);

              this.getsemestercourse(found.id);
            } else if (this.sem_course[0]) {
              this.activeTab = this.sem_course[0].semester;
              this.activeDepartment = this.sem_course[0].department.name;
              console.log("foactiveDepartment2", this.activeDepartment);
              console.log("foactiveDepartment123456", this.sem_course[0].id);

              this.getsemestercourse(this.sem_course[0].id);
            }

            console.log("this.sem_course", this.sem_course);
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        });
    },

    async getsemestercourse(id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-semester-get/${this.studentdata.studentId}/?semester__id=${id}&Key=${this.studentdata.studentToken}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            // this.getCourseListbySemester = response.data.data.data[0].semester;
            const semesterData = response.data.data.data[0].semester;

            this.getCourseListbySemester = semesterData.map((sem) => ({
              ...sem,
              course: sem.course.filter(
                (course) => course.published_course?.published === true,
              ),
            }));
            console.log("this.getCourseListbySemester3333",this.getCourseListbySemester)
          }
        });
    },
  },
};
</script>

<style scoped></style>
